import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './paragraph.styles';
import Paragraph from './paragraph';

export default compose(withStyles(styles))(Paragraph);
